import { render } from "./HelpIcon.vue?vue&type=template&id=c632a27c"
import script from "./HelpIcon.vue?vue&type=script&lang=js"
export * from "./HelpIcon.vue?vue&type=script&lang=js"

import "./HelpIcon.vue?vue&type=style&index=0&id=c632a27c&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__